<template>
    <el-dialog :mask-closable="false" :visible.sync="showModal" width="488" :title="modalheader">
        <p slot="header" class="modalHead">
            <span>{{modalheader}}</span>
        </p>
        <div class="modalContent">
            <p>
              
              {{$t('cashAccount.remittance.modalTipsWarn1')}}
              <i style="color:#1FA0E8; font-style:normal">
                {{$t('cashAccount.remittance.modalTipsWarn2')}}
              </i>
              {{$t('cashAccount.remittance.modalTipsWarn3')}}</p>
        </div>
        <div slot="footer" class="textright">
            <pp-button class="pp-btn pp-btn-ghost pp-btn-spec" @click="toService">{{modalbtn}}</pp-button>
            <pp-button class="pp-btn pp-btn-primary pp-btn-spec" @click="leftBtnFun">{{$t('cashAccount.remittance.confirm')}}</pp-button>
        </div>
    </el-dialog>
</template>

<script>
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

export default {
  name: "successModal",
  props: {
    // tourl: "",
    // modalcontent: "",
    modalheader: "",
    modalbtn: ""
  },
  mounted() {},
  data() {
    return {
      showModal: false
    };
  },
  methods: {
    // 联系客服
    toService() {
      let win = window.open();
      this.$openHref("http://q.url.cn/cdiXhC?_type=wpa&qidian=true", win);
    },
    leftBtnFun() {
      this.showModal = false;
      this.$emit("close");
    },
    show() {
      this.showModal = true;
    },
    close() {}
  }
};
</script>

<style lang="scss" scoped>
.modalHead {
  color: #000;
  font-size: 20px;
  text-align: left;
}

.modalContent {
  text-align: left;
  font-size: 14px;
}
</style>
